import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { materialize } from 'rxjs/internal/operators/materialize';
import { delay } from 'rxjs/internal/operators/delay';
import { dematerialize } from 'rxjs/internal/operators/dematerialize';

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // array in local storage for registered users

        // wrap in delayed observable to simulate server api call
        return of(null).pipe(mergeMap(() => {
            // authenticate
            // if ((request.url.indexOf(AppConfig.endpoints.authenticate.byId) > -1)) {
            //     // console.log('req', request);
            //     // if (request.body.personalId.length === 1) {
            //     //     if (request.body.personalId === '1') {
            //     //         // return of(new HttpResponse({ status: 200, body: {data: 'someData'} }));
            //     //         return of(new HttpResponse({
            //     //             status: LoginIdResponseType.OK.status,
            //     //             body: LoginCheckResponseType.OK
            //     //         }));
            //     //     } else if (request.body.personalId === '2') {
            //     //         return of(new HttpResponse({
            //     //             status: LoginIdResponseType.NO_SUCH_ID.status,
            //     //             body: LoginIdResponseType.NO_SUCH_ID
            //     //         }));
            //     //     } else if (request.body.personalId === '3') {
            //     //         return of(new HttpResponse({
            //     //             status: LoginIdResponseType.MULTIPLE_IDENTIFIERS.status,
            //     //             body: LoginIdResponseType.MULTIPLE_IDENTIFIERS,
            //     //         }));
            //     //     }
            //     //     return of(new HttpResponse({ status: 401, body: { code: 'otherError', message: 'Друго' } }));
            //     // } else {
            //     //     // else return 400 bad request
            //     //     return throw('');
            //     // }
            // } else if ((request.url.indexOf(AppConfig.endpoints.authenticate.getQrCode) > -1) && request.method === 'GET') {
            //     return of(new HttpResponse({ status: 200, body: { data: { qrString: 'test' } } }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.authenticate.authenticate) > -1)) {

            //     return of(new HttpResponse({
            //         status: LoginCheckResponse.OK.status,
            //         body: LoginCheckResponse.OK
            //     }));

            // } else if ((request.url.indexOf(AppConfig.endpoints.authenticate.logout) > -1)) {
            //     return of(new HttpResponse({
            //         status: 200,
            //         body: {}
            //     }));
            // } else if (request.url === AppConfig.endpoints.certificates) {
            //     return of(new HttpResponse({
            //         status: 200,
            //         body: { data: certDataMock }
            //     }));
            // } else if (request.url === AppConfig.endpoints.devices) {
            //     return of(new HttpResponse({
            //         status: 200,
            //         body: { data: devicesDataMock }
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.operations.hold) > -1)) {
            //     return of(new HttpResponse({
            //         status: 200,
            //         body: { data: {} }
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.operations.restore) > -1)) {
            //     return of(new HttpResponse({
            //         body: RestoreCertResponse.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.operations.addDevice) > -1 && request.method === 'POST')) {
            //     return of(new HttpResponse({
            //         status: AddDeviceResponsePost.OK.status,
            //         body: AddDeviceResponsePost.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.operations.addDevice) > -1 && request.method === 'GET')) {
            //     return of(new HttpResponse({
            //         status: AddDeviceResponseGet.WAITING_FOR_CONFIRMATION.status,
            //         body: AddDeviceResponseGet.WAITING_FOR_CONFIRMATION
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.profile.email) > -1 && request.method === 'POST')) {
            //     EmailCodeSend.REGISTRATION_NOT_FINISHED.data.expTimestamp = timeoutInMinutes(1);
            //     return of(new HttpResponse({
            //         status: EmailCodeSend.REGISTRATION_NOT_FINISHED.status,
            //         body: EmailCodeSend.REGISTRATION_NOT_FINISHED
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.profile.validateEmail) > -1 && request.method === 'POST')) {
            //     return of(new HttpResponse({
            //         status: EmailCodeVerification.EMAIL_VERIFICATION_SUCCESSFUL.status,
            //         body: EmailCodeVerification.EMAIL_VERIFICATION_SUCCESSFUL
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.profile.phoneNumber) > -1 && request.method === 'POST')) {
            //     SMSSend.SMS_SENT.data.expTimestamp = timeoutInMinutes(1);
            //     return of(new HttpResponse({
            //         status: SMSSend.SMS_SENT.status,
            //         body: SMSSend.SMS_SENT
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.profile.validateOTPCode) > -1 && request.method === 'POST')) {
            //     return of(new HttpResponse({
            //         status: SMSVerification.PHONENUMBER_VERIFICATION_SUCCESSFUL.status,
            //         body: SMSVerification.PHONENUMBER_VERIFICATION_SUCCESSFUL
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.devices) > -1 && request.method === 'DELETE')) {
            //     return of(new HttpResponse({
            //         status: DeleteDeviceResponse.OK.status,
            //         body: DeleteDeviceResponse.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.history.signing) > -1 && request.method === 'GET')) {
            //     return of(new HttpResponse({
            //         status: CertificateHistoryResponse.OK.status,
            //         body: CertificateHistoryResponse.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.orders) > -1 && request.method === 'GET')) {
            //     return of(new HttpResponse({
            //         status: OrderResponse.OK.status,
            //         body: OrderResponse.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.orders) > -1 && request.method === 'POST')) {
            //     return of(new HttpResponse({
            //         status: OrderPostResponseMock.OK.status,
            //         body: OrderPostResponseMock.OK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.order.status) > -1 && request.method === 'GET')) {
            //     return of(new HttpResponse({
            //         status: GetPaymentStatusResponseMock.NOK.status,
            //         body: GetPaymentStatusResponseMock.NOK
            //     }));
            // } else if ((request.url.indexOf(AppConfig.endpoints.order.paymentLink) > -1 && request.method === 'GET')) {
            //     return of(new HttpResponse({
            //         status: GetPaymentLinkResponseMock.OK.status,
            //         body: GetPaymentLinkResponseMock.OK
            //     }));
            // }

            // pass through any requests not handled above
            return next.handle(request);

        }))

            // call materialize and dematerialize to ensure delay even if an error is thrown
            // (https://github.com/Reactive-Extensions/RxJS/issues/648)
            .pipe(
                materialize(),
                delay(300),
                dematerialize()
            );
    }
}

export let fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};
